import {
  Box,
  Text
} from '@chakra-ui/react';

const DataBox = ({
  label, 
  data,
  color,
  containerStyles
}) => {
  return (
    <Box flex={1}>
      <Text
        color={"#000000"}
        fontFamily={"PlusJakartaSansMedium"}
        fontSize={"12px"}
        marginBottom={2}
      >
        {label}
      </Text>
      <Box
        padding={"12px"}
        borderWidth={1}
        borderRadius={"4px"}
        borderColor={"#D9D9D9"}
        borderStyle={"solid"}
        style={containerStyles}
        height={"48px"}
      >
        <Text
          color={color ? color : "#898989"}
          fontFamily={"PlusJakartaSansRegular"}
          fontSize={"12px"}
        >
          {data}
        </Text>
      </Box>
    </Box>
  );
}

export default DataBox;